// import { useSelectLoginState } from 'Auth/data';
// import { useSelectUserTheme } from 'User/data';
// import { useAppDispatch } from 'Store';

export const ThemeSwitcher = () => {
  // const dispatch = useAppDispatch();
  // const currentTheme = useSelectUserTheme();
  // const loginState = useSelectLoginState();

  // const handleChangeTheme = () => {
  //   const newTheme = currentTheme === Themes.light ? Themes.dark : Themes.light;
  //   const isLogged = loginState === LoginState.LOGGED;
  //   dispatch(saveThemeWithBackend({ theme: newTheme, isLogged }));
  // };

  return null; // TODO: wait for design

  // return (
  //   <StyledWrapper>
  //     <ThemeSwitcherButton onClick={handleChangeTheme} color="inherit">
  //       {currentTheme === Themes.dark ? <Brightness7Icon /> : <Brightness4Icon />}
  //     </ThemeSwitcherButton>
  //   </StyledWrapper>
  // );
};
